import type {
  GetSingleFocusAreaBehaviorId,
  GetSingleOptionId,
  IsCurrentValueEqualToSingleOption,
  ShouldSkipAutoSelect,
} from './types/autoSelect';

export const isCurrentValueEqualToSingleOption: IsCurrentValueEqualToSingleOption = (
  currentValue,
  singleOptionValue,
) =>
  currentValue != null &&
  currentValue !== '' &&
  (currentValue === singleOptionValue || Number(currentValue) === Number(singleOptionValue));

export const shouldSkipAutoSelect: ShouldSkipAutoSelect = ({
  hasUserCleared,
  isEditing,
  currentId,
  singleId,
  hasAutoSelectedForCurrent,
}) =>
  hasUserCleared ||
  !isEditing ||
  isCurrentValueEqualToSingleOption(currentId, singleId) ||
  hasAutoSelectedForCurrent;

export const getSingleOptionId: GetSingleOptionId = (options) => {
  if (options?.length === 1 && options[0]?.id != null) {
    return options[0].id;
  }
  return undefined;
};

export const getSingleFocusAreaBehaviorId: GetSingleFocusAreaBehaviorId = (options) => {
  if (options?.length === 1 && options[0]?.id != null) {
    return options[0].id;
  }
  return undefined;
};
